import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WaveDividerProps {
    className?: string
}

// A soft wave that hands one section over to the next. The fill follows the text colour class.
export const WaveDivider: FC<WaveDividerProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 1440 80'
            preserveAspectRatio='none'
            aria-hidden='true'
            className={cn('-mb-px block h-10 w-full sm:h-16', className)}
        >
            <path fill='currentColor' d='M0 40C240 80 480 0 720 32S1200 16 1440 40V80H0Z' />
        </svg>
    )
}
